<script setup lang="ts">
import { vOnClickOutside } from "@vueuse/components";
import { OnClickOutsideOptions } from "@vueuse/core";
import { defineComponent, ref, useSlots, watch } from "vue";

const dropdownState = ref(false);
const emit = defineEmits(["opened"]);
const triggerButton = ref(null);

const onClickOutsideHandler: [(evt: any) => void, OnClickOutsideOptions] = [
  () => {
    close();
  },
  { ignore: [triggerButton] },
];

emit("opened", dropdownState);

const open = () => {
  dropdownState.value = true;
};

const close = () => {
  dropdownState.value = false;
};

watch(dropdownState, () => {
  emit("opened", dropdownState);
});

const slots = useSlots();

const trigger = defineComponent({
  render: () => {
    const trigger = slots.default?.()[0];
    if (!trigger) { 
      return 
    }
    if (!trigger.props) {
      trigger.props = {}
    }
    trigger.props.open = open;
    trigger.props.state = dropdownState.value;
    return trigger;
  },
});

const content = defineComponent({
  render: () => {
    const content = slots.default?.()[1];
    if (!content) {
      return
    }
    if (!content.props) {
      content.props = {}
    }
    content.props.close = close;
    content.props.state = dropdownState.value;
    return content;
  },
});
</script>

<template>
  <div class="dropdown">
    <trigger ref="triggerButton" @click.stop="open" />
    <content v-on-click-outside="onClickOutsideHandler" />
  </div>
</template>

<style scoped lang="scss">
.dropdown {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
